import { loadStripe } from '@stripe/stripe-js';

// Get the Stripe publishable key from environment
const stripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Log for debugging
if (!stripeKey) {
  console.error('Stripe publishable key not found! Make sure VITE_STRIPE_PUBLISHABLE_KEY is set.');
}

// Initialize Stripe with the publishable key
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

// Determine if we're in production based on the Supabase URL
const isProduction = import.meta.env.VITE_SUPABASE_URL?.includes('censxitkytjascayhgmc');

export { stripePromise };

// Stripe product/price IDs - different for test vs live
export const STRIPE_PRICES = isProduction ? {
  // Production (Live) Price IDs - UPDATED 2025-10-28
  STARTER_MONTHLY: 'price_1SNImvP06JDNK185OFJs8Yae',       // Live: Starter Monthly - $99/month
  STARTER_ANNUAL: 'price_1SNIlsP06JDNK185K3NHpVOe',        // Live: Starter Annual - $990/year
  STANDARD_MONTHLY: 'price_1RlOesP06JDNK185w5Fwvu56',      // Live: Standard Monthly - $199/month (prod_SgmDUQ7yyWrjE3)
  STANDARD_ANNUAL: 'price_1Ruu3SP06JDNK185JM6x8SP0',       // Live: Standard Annual - $1,990/year (prod_SqbFeVcmPTy4JQ)
  PRO_MONTHLY: 'price_1RraMQP06JDNK185C5saFuXg',          // Live: Pro Monthly - $299/month (prod_SnAhNlkEnZJF9R)
  PRO_ANNUAL: 'price_1Ruu2OP06JDNK1856phLzSCW',           // Live: Pro Annual - $2,990/year (prod_SqbEtj5DHe9Ylc)
  // Add-On Products (Live)
  ADD_ON_ENVIRONMENT_MONTHLY: 'price_1Rmo59P06JDNK185tHca4WDe',  // Live: Additional Environment (Org) - $99/month
  ADD_ON_ENVIRONMENT_ANNUAL: 'price_1Rmo59P06JDNK185wXtzzjHk',   // Live: Additional Environment (Org) - $990/year
  ADD_ON_WORKSPACE_MONTHLY: 'price_1Rmo6sP06JDNK185bdeoj6ts',    // Live: Additional Workspace - $149/month (not currently available)
  ADD_ON_WORKSPACE_ANNUAL: 'price_1Rmo6sP06JDNK185Tr7I5L9a',     // Live: Additional Workspace - $1,490/year (not currently available)
} : {
  // Staging (Test) Price IDs
  STARTER_MONTHLY: 'price_1SNIrYP06JDNK185jiQHuk65',       // Test: Starter Monthly - $99/month
  STARTER_ANNUAL: 'price_1SNIsHP06JDNK1856amPuTgZ',        // Test: Starter Annual - $990/year
  STANDARD_MONTHLY: 'price_1RlOBaP06JDNK1854v9RicHT',      // Test: Standard Monthly - $199/month
  STANDARD_ANNUAL: 'price_1RlOEzP06JDNK1859sJnHbXL',       // Test: Standard Annual - $1,990/year
  PRO_MONTHLY: 'price_1RlOHrP06JDNK185sezXyIQE',          // Test: Pro Monthly - $299/month
  PRO_ANNUAL: 'price_1RlOKSP06JDNK185qrjMHLGh',           // Test: Pro Annual - $2,990/year
  // Add-On Products (Test)
  ADD_ON_ENVIRONMENT_MONTHLY: 'price_1RlORlP06JDNK185HTza6vuU',  // Test: Additional Environment (Org) - $99/month
  ADD_ON_ENVIRONMENT_ANNUAL: 'price_1RlOScP06JDNK185xcbpJu2j',   // Test: Additional Environment (Org) - $990/year
  ADD_ON_WORKSPACE_MONTHLY: 'price_1RlOUIP06JDNK185ekNNBV5b',    // Test: Additional Workspace - $149/month (not currently available)
  ADD_ON_WORKSPACE_ANNUAL: 'price_1RlOUIP06JDNK185MPmUSZW6',     // Test: Additional Workspace - $1,490/year (not currently available)
};

// Coupon codes
export const COUPON_CODES = {
  BETA50: 'BETA50', // $50 off Standard
  BETA100: 'BETA100', // $100 off Pro
  EARLY30: 'EARLY30', // 30% off for 3 months
  LAUNCH25: 'LAUNCH25', // 25% off for 6 months
  PARTNER20: 'PARTNER20', // 20% off recurring
  BETATESTER30: 'BETATESTER30', // 30 days free for beta testers (100% off first month)
  FREETRIAL30: 'FREETRIAL30', // Alternative: 30-day free trial code
};